/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ApplicationConfig } from '../models/application-config';
import { ReleaseNotes } from '../models/release-notes';
@Injectable({
  providedIn: 'root',
})
class ConfigService extends __BaseService {
  static readonly ConfigGetApplicationConfigPath = '/api/Config/GetApplicationConfig';
  static readonly ConfigGetReleaseNotesPath = '/api/Config';
  static readonly ConfigGetWebManifestPath = '/api/Config/GetWebManifest';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  ConfigGetApplicationConfigResponse(): __Observable<__StrictHttpResponse<ApplicationConfig>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Config/GetApplicationConfig`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ApplicationConfig>;
      })
    );
  }  ConfigGetApplicationConfig(): __Observable<ApplicationConfig> {
    return this.ConfigGetApplicationConfigResponse().pipe(
      __map(_r => _r.body as ApplicationConfig)
    );
  }
  ConfigGetReleaseNotesResponse(): __Observable<__StrictHttpResponse<ReleaseNotes>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Config`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ReleaseNotes>;
      })
    );
  }  ConfigGetReleaseNotes(): __Observable<ReleaseNotes> {
    return this.ConfigGetReleaseNotesResponse().pipe(
      __map(_r => _r.body as ReleaseNotes)
    );
  }
  ConfigGetWebManifestResponse(): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Config/GetWebManifest`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }  ConfigGetWebManifest(): __Observable<Blob> {
    return this.ConfigGetWebManifestResponse().pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module ConfigService {
}

export { ConfigService }
